export const API_ENDPOINT_URL = process.env.REACT_APP_API_ENDPOINT_URL
export const SIGNALR_ENDPOINT_URL = process.env.REACT_APP_SIGNALR_ENDPOINT_URL
export const SPEECH_KEY = process.env.REACT_APP_SPEECH_KEY
export const SPEECH_REGION = process.env.REACT_APP_SPEECH_REGION